import { z } from "zod";
import { CATEGORIAS_FEEDBACK } from "../api/feedbackApi";

const CATEGORY_VALUES = CATEGORIAS_FEEDBACK.map((c) => c.value);

// Limites alinhados a domain.NewFeedback no backend (mensagem aparada, 1..2000; categoria
// obrigatória). O select começa vazio, então "" também cai na mensagem de categoria.
export const feedbackSchema = z.object({
  category: z.enum(CATEGORY_VALUES, { message: "Escolha uma categoria" }),
  message: z
    .string()
    .trim()
    .min(1, "Escreva sua mensagem")
    .max(2000, "A mensagem deve ter no máximo 2000 caracteres"),
});
